import React from "react";
import "./Order_details_table.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { Form, Table } from "react-bootstrap";
import { variant_type } from "../../../../../utils/common";

function Order_details_table({
  selectedItems,
  setSelectedItems,
  setError,
  order,
}) {
  const handleCheckboxChange = (val) => {
    setError("");
    setSelectedItems((prev) => {
      const exists = prev.some((item) => item.id === val.id); // use a unique ID or index
      if (exists) {
        return prev.filter((item) => item.id !== val.id);
      } else {
        return [...prev, val]; // or just store val.id if needed
      }
    });
  };
  return (
    <>
      {order?.Product_Order_Details?.map((product) => (
        <div className="product_content_holder cancel_order_details_table">
          <div className="product_content">
            <div className="product_detail_inner">
              <div className="left_side">
                <Form.Check
                  type={"checkbox"}
                  className="cancel_check"
                  checked={selectedItems?.some(
                    (item) => item.id === product.id,
                  )}
                  onChange={() => handleCheckboxChange(product)}
                />
                <div className="img_holder">
                  <img
                    src={
                      process.env.REACT_APP_IMG_URL + product?.Product?.image
                    }
                  />
                </div>

                <div className="text_holder">
                  <div className="product_name">
                    <p>{product?.Product?.name}</p>
                  </div>
                  <div className="weight">
                    <h6>
                      {product?.Product?.variant_type_id ===
                        variant_type.Single && (
                        <>
                          <strong>Mattress Size:</strong>{" "}
                          {product?.Product_Variant?.Metal?.name}
                        </>
                      )}

                      {product?.Product?.variant_type_id ===
                        variant_type.Double && (
                        <>
                          <strong>Mattress Size:</strong>{" "}
                          {
                            product?.Double_Variant?.Product_Variant?.Metal
                              ?.name
                          }
                          , <strong>Thickness:</strong>{" "}
                          {product?.Double_Variant?.Size?.name}{" "}
                        </>
                      )}

                      {product?.Product?.variant_type_id ===
                        variant_type.Triple && (
                        <>
                          <p className="sub_text">
                            <strong>Mattress Size:</strong>{" "}
                            {
                              product?.Triple_Variant?.Double_Variant
                                ?.Product_Variant?.Metal?.name
                            }
                            ,
                            {
                              product?.Triple_Variant?.Double_Variant?.Size
                                ?.name
                            }
                            ,{" "}
                          </p>
                          <p className="sub_text">
                            <strong>Thickness:</strong>{" "}
                            {product?.Triple_Variant?.Diamond?.name}
                          </p>
                        </>
                      )}
                    </h6>
                  </div>
                </div>
              </div>

              <div>
                <div className="qty_holder">
                  <p>
                    x {product?.quantity}{" "}
                    <span className="price">
                      {(
                        Number(product?.selling_price) +
                        Number(product?.total_tax)
                      ).toFixed(2)}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
}

export default Order_details_table;
